module.exports = __webpack_public_path__ + "img/gobConWeb.be1be453.png";